import {Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PrintPlayerComponent} from '../print-player/print-player.component';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import * as fromSite from '../../../site/reducers';
import * as fromRoot from '../../reducers';
import {Site} from '../../models/site';
import {map, skipWhile} from 'rxjs/operators';
import {LoadSiteAction, SiteClearAction} from '../../../site/actions/site-load';
import * as fromShared from '../../reducers';
import {Observable, Subscription} from 'rxjs';
import * as _ from 'lodash';
import {Role} from '../..';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {HeaderTitleClearAction} from '../../actions/header-title';
@Component({
  selector: 'storever-header-page',
  templateUrl: './header-page.component.html',
  styleUrls: ['./header-page.component.scss']
})
export class HeaderPageComponent implements OnChanges , OnDestroy {

  @ViewChild('printPlayerModalIp', {static: false}) printPlayerModalIp: PrintPlayerComponent;
  @ViewChild('printPlayerModalAddress', {static: false}) printPlayerModalAddress: PrintPlayerComponent;
  @Input() title: string;
  @Input() icon: string;
  @Input() isEdit: boolean;
  @Input() titleRef: string;
  @Input() orderType: number;
  @Input() buttonTitle: string;
  @Input() buttonIcon: string;
  @Input() buttonRole: string;
  @Input() buttonTitleExtra: string;
  @Input() buttonIconExtra: string;
  @Input() actionTypeExtra: string;
  @Input() allowOrderCreation = true;
  // tslint:disable-next-line:no-any
  @Input() list: Observable<any[]>;
  @Input() filterVue: string;
  @Input() filterPlaceholder: string;
  @Input() action: string;
  @Input() href: string[];
  @Input() isList: boolean;
  @Input() data: Object[];
  @Input() breadcrumbsData: Object[];
  roles$: Observable<Role[]>;

  @Input() actionType: string;
  @Output() _action = new EventEmitter<string>();
  @Output() breadRedirectList = new EventEmitter<object>();
  @Output() breadRedirectName = new EventEmitter();
  private sub$: Subscription;
  private subscriptions = [];
  constructor(private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromSite.AppState>,
              private storeRoot: Store<fromRoot.AppState>,
              private activatedRoute: ActivatedRoute) {
    this.list = this.store.pipe(select(fromShared.selectors.getMyClients));
    this.roles$ = this.storeRoot.pipe(select(fromRoot.selectors.getMyRoles));

  }

  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.href && changes.href.currentValue) {
      if (this.router.url.includes('/sites/detail/')) {
        this.sub$ = this.activatedRoute.parent.params.subscribe(params => {
          if (params.clientId) {
            this.store.pipe(
              skipWhile(data => !data),
              select(fromSite.selectors.getSite)
            ).subscribe((site: Site) => {
              if (site && site.uuid) {
                this.href = ['/', 'shippings', 'add', 'client', params.clientId, 'site', site.uuid]
              } else {
                const siteId = this.activatedRoute.snapshot.paramMap.get('id');
                // this.store.dispatch(new LoadSiteAction(siteId))
              }
            })
          }
        });
        this.subscriptions.push(this.sub$);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  actions(): void {
    this._action.emit(this.actionType);
  }

  actionsExtra(): void {
    this._action.emit(this.actionTypeExtra);
  }

  redirectName(type: string): void {
    this.breadRedirectName.emit(type);
  }

  redirectList(type: string , uuid: string): void {
    this.breadRedirectList.emit({type: type, uuid: uuid});
  }
}
